<template>
    <b-modal
            v-model="modal.state"
            :modal-class="internalModalClass"
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-footer
            :hide-header="hideHeader"
    >
        <template v-slot:modal-header>
            <div>
                <template v-if="showBackButton">
                    <i
                            class="icon far fa-arrow-left"
                            @click="back"
                    />
                </template>
            </div>

            <slot name="title" />

            <div>
                <template v-if="showCloseButton">
                    <i
                            class="icon far fa-times"
                            @click="close"
                    />
                </template>
            </div>
        </template>
        <template slot="default">
            <slot
                    name="content"
                    :payload="payload"
                    :close="close"
            />
        </template>
    </b-modal>
</template>

<script>
    import './ModalFullWidth.scss';

    export default {
        name: "ModalFullWidth",
        props: {
            modalClass: {
                type: String,
                default: ''
            },
            eventName: {
                type: String,
                required: true
            },
            showCloseButton: {
                type: Boolean,
                default: true
            },
            showBackButton: {
                type: Boolean,
                default: false
            },
            afterShow: {
                type: Function,
                default: () => {
                }
            },
            afterClose: {
                type: Function,
                default: () => {
                }
            },
            hideHeader: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                modal: {
                    state: false,
                    openEvent: this.eventName,
                    closeEvent: this.eventName + '-close',
                },
                payload: null,
            };
        },
        computed: {
            internalModalClass() {
                return 'pl-0 modal-full-width ' + this.modalClass;
            }
        },
        methods: {
            initPayload(payload) {
                this.payload = payload;
                this.$emit('update:payload', this.payload);
            },
            show(payload) {
                this.modal.state = true;
                this.initPayload(payload);
                this.afterShow();
            },

            close() {
                this.modal.state = false;
                this.afterClose();
                this.$uiBus.$emit(this.modal.closeEvent);
                this.$emit('close');
            },

            back() {
                this.$emit('back');
            },
        },

        beforeMount() {
            this.$uiBus.$on(this.modal.openEvent, this.show);
        },

        beforeDestroy() {
            this.$uiBus.$off(this.modal.openEvent, this.show);
        }
    };
</script>
